import { create } from "zustand";
import type { IBrands } from "../hooks/http/colab/workspace/get-workspace.hook";

interface IWorkspaceStore {
  data: IBrands | null;
  setData: (data: IBrands) => void;
}
const useWorkspaceStore = create<IWorkspaceStore>((set) => ({
  data: null,
  setData: (data: IBrands) => set(() => ({ data })),
}));

export default useWorkspaceStore;
